<!-- 添加、编辑集控器弹框 -->
<template>
  <el-dialog
    title="添加设备"
    :visible.sync="modalShow"
    width="1000px"
    :before-close="modalClose"
  >
    <!-- 设备列表 -->
    <el-form :inline="true" ref="deviceForm" :model="deviceForm" class="demo-form-inline">
        
        <el-form-item label="设备号" prop="device_serial">
            <el-input v-model="deviceForm.device_serial" clearable placeholder="设备号" style="width:150px;"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="deviceType">
            <el-select v-model="deviceForm.devtype" :disabled="devType>0" clearable placeholder="请选择设备类型"  style="width:150px;">
                <el-option
                    v-for="v in baseData.devtype"
                    :key="v.value"
                    :label="v.label"
                    :value="v.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="选择楼宇" prop="resident">
            <cmp-build-select
                    :buildRoom="buildRoom"
                    changeOnSelect
                    @listenBuildResult="listenBuildResult"></cmp-build-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
    </el-form>
    <el-table
        ref="multipleTable"
        height="320"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="terminal_serial" label="序列号" sortable>
        </el-table-column>
        <el-table-column prop="device_model" label="表计型号">
        </el-table-column>
        <el-table-column prop="dev_type" label="表计类型" :formatter="fmtDevType" sortable>
        </el-table-column>
        <el-table-column prop="collector_name" label="集控器名称">
        </el-table-column>
        <el-table-column prop="house_name" label="安装位置">
        </el-table-column>
        <el-table-column prop="online_status" label="通讯状态" :formatter="fmtStatus" sortable>
        </el-table-column>
    </el-table>
    <div style="text-align:right;margin-top:10px;">
        <el-button type="primary" @click="handleSave">确定添加</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
import { funFmtDevType, funFmtOnlineStatus } from '@/utils/utils'
export default {
    name: "cmpaddequipmentdialog",
    inject: ["reload"],
    data() {
        return {
            deviceForm: {
				is_house:false,
				
			},   // 筛选设备表单参数
            // 选择房间组件
            buildRoom: {},

            tableData: [],  // 设备列表
            loading: false,
            multipleSelection: []
        };
    },
    props: {
        modalShow: Boolean,
        defaultList: Array,
        devType: Number,
    },
    computed: {
        ...mapGetters(['baseData']),
    },
    components: {
        CmpBuildSelect
    },
    created() {
        if(this.devType>0) {
            this.deviceForm.devtype = this.devType
        }
        this.onSubmit();
    },
    methods: {
        // 查询设备
        async onSubmit() {
            // this.loading = true;
            let data = await Service.getMeterDeviceList(this.deviceForm);
            if(data) {
                data = data === 'success' ? [] : data;

                // 过滤已经添加的设备
                let ids = this.defaultList.map(v=>{return v.oid})
                this.tableData = data.filter(v=>{
                    return !ids.includes(v.oid) && v.dev_type != 3;  //  过滤已经添加表计跟热量表
                });
                if(data.length>0 && this.tableData.length == 0){
                    this.$notify.info({
                        title: '温馨提示',
                        message: '您已添加所有设备，暂无可添加的设备'
                    });
                }
            }
			for(var i = 0;i < this.tableData.length;i++){
				if(this.tableData[i].moduleid_list){
					let arr = JSON.parse(this.tableData[i].moduleid_list);
					this.tableData[i].house_name=arr[0].modulename + arr[1].modulename + this.tableData[i].house_name
				}
				
			}
            // this.loading = false;
        },
        // 建筑确认信息
        listenBuildResult(data) {
			if(data.householdid === undefined) {
				// 建筑
				this.deviceForm.is_house = false
			}else{
				// 房间
				this.deviceForm.is_house = true
			}
            this.deviceForm.moduleid = data.oid;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //   关闭弹框
        modalClose() {
            // 清空表单信息
            this.$emit("update:modalShow", false);
        },
        // 确认添加
        async handleSave() {
            let arr = [];
            this.multipleSelection.map(v=> {
                arr.push({ oid: v.oid });
            })
            if(arr.length == 0) {
                this.$notify({
                    title: '警告',
                    message: '请选择要添加的设备',
                    type: 'warning'
                });
                return
            }
            let devices = arr.concat(this.defaultList);
            
            // 数组去重
            let hash = {};
            devices = devices.reduce((preVal, curVal)=>{
                hash[curVal.oid] ? '' : hash[curVal.oid] = true && preVal.push(curVal);
                return preVal
            }, [])

            let OID = this.$route.params.groupId;
            let data = await Service.editDevGroupMeter({ devices, OID });
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },

        // 格式通讯状态
        fmtStatus(row) {
            return funFmtOnlineStatus(row.online_status)
        },
        // 格式化表计类型
        fmtDevType(row) {
            return funFmtDevType(row.dev_type);
        },
    },
};
</script>
<style lang='less' scoped>

</style>